"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const banner_1 = __importDefault(require("@kyruus/banner"));
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const PhoneNumberLink_1 = __importDefault(require("./PhoneNumberLink"));
const SchedulingHelpBanner = ({ phone }) => {
    if (!phone)
        return null;
    return (react_1.default.createElement(banner_1.default, { "data-testid": "SchedulingHelpBanner", type: "info", icon: "i" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.schedulingHelp, { values: {
                phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
            } }))));
};
exports.default = SchedulingHelpBanner;
//# sourceMappingURL=SchedulingHelpBanner.js.map